import React from 'react';
import styled from 'styled-components';
import { Text, TextButton, IconButtonProps, IconButton } from '@oneaudi/unified-web-components';
import {
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_SPACE_FIXED_500,
  SYS_SPACE_RELATIVE_LG,
  SYS_SPACE_RELATIVE_XS,
  SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT,
  SYS_PAGE_MARGIN_XS,
  SYS_BREAKPOINT_SM,
  SYS_PAGE_MARGIN_SM,
  SYS_PAGE_MARGIN_MD,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_2_XL,
  SYS_SPACE_FIXED_1200,
  SYS_SPACE_FIXED_100,
} from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper, GetSafeColorDesignToken } from '@oneaudi/vtp-shared';
import { SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-alpha-common';

export const QuickFilters = styled.div`
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: block;
  }
`;

export const QuickFiltersWrapper = styled.div`
  ${dynamicStyling({
    legacy: `
    padding: 64px ${SYS_PAGE_MARGIN_XS} ${SYS_PAGE_MARGIN_XS} ${SYS_PAGE_MARGIN_XS}; 
    margin-bottom: 73px;
  `,
    alpha: `
    padding: 48px ${SYS_PAGE_MARGIN_XS} calc(${SYS_SPACE_FIXED_1200} + ${SYS_PAGE_MARGIN_XS} - ${SYS_SPACE_FIXED_500}) ${SYS_PAGE_MARGIN_XS};
  `,
  })};

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    ${dynamicStyling({
      legacy: `
      padding: ${SYS_PAGE_MARGIN_SM}; 
    `,
      alpha: `
      padding: 32px ${SYS_PAGE_MARGIN_SM} calc(${SYS_SPACE_FIXED_1200} + ${SYS_PAGE_MARGIN_SM} - ${SYS_SPACE_FIXED_500}) ${SYS_PAGE_MARGIN_SM};
    `,
    })};
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    ${dynamicStyling({
      legacy: `
        padding: ${SYS_PAGE_MARGIN_MD}; 
      `,
      alpha: `
        padding: 32px ${SYS_PAGE_MARGIN_MD} calc(${SYS_SPACE_FIXED_1200} + ${SYS_PAGE_MARGIN_MD} - ${SYS_SPACE_FIXED_500}) ${SYS_PAGE_MARGIN_MD};
      `,
    })};
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    min-width: ${dynamicStylingHelper('257px', '250px')};
    max-width: ${dynamicStylingHelper('257px', '250px')};
    padding: 0;
    position: relative;
    left: 1px;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    min-width: 296px;
    max-width: 296px;
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    min-width: ${dynamicStylingHelper('412px', '407px')};
    max-width: ${dynamicStylingHelper('412px', '407px')};
  }
`;

export const RenderedQuickFiltersWrapper = styled.div``;

export const SelectedFiltersHeadline = styled(Text)`
  ${dynamicStylingHelper('color: var(--Sem-Color-Forms-Foreground-Text-Caption, #666666)')};
`;

export const QuickFiltersFooter = styled.div`
  display: flex;
  padding: ${dynamicStylingHelper(
    `${SYS_SPACE_RELATIVE_XS} ${SYS_SPACE_RELATIVE_LG}`,
    `${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN_XS}`
  )};
  margin-top: ${dynamicStylingHelper(SYS_SPACE_FIXED_500, '0')};
  border-top: ${dynamicStylingHelper(`1px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT}`, 'unset')};
  ${dynamicStyling({
    legacy: `
        box-shadow: 0px 8px 16px 0px ${GetSafeColorDesignToken('INDICATOR_DEFAULT_DARK')}`,
  })}
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${GetSafeColorDesignToken('QUICK_FILTERS_FOOTER')};
  backdrop-filter: blur(${GetSafeColorDesignToken('FILTER_OVERLAY_BLUR')});
  > * {
    width: 50%;
  }
  > :first-child {
    justify-content: center;
    align-items: ${dynamicStylingHelper('unset', 'start')};
  }
  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    padding: ${dynamicStylingHelper(
      `${SYS_SPACE_RELATIVE_XS} ${SYS_SPACE_RELATIVE_LG}`,
      `${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN_SM}`
    )};
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: ${dynamicStylingHelper(
      `${SYS_SPACE_RELATIVE_XS} ${SYS_SPACE_RELATIVE_LG}`,
      `${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN_MD}`
    )};
    justify-content: space-between;
    > * {
      width: unset;
    }
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-top: 0;
    border-top: unset;
    box-shadow: unset;
    position: static;
    justify-content: center;
    padding: unset;
    > :first-child {
      justify-content: unset;
      align-items: unset;
    }
    > * {
      width: 100%;
    }
    background: unset;
  }
`;

export const StyledCloseButton = styled((props) => <IconButton {...props} />)<IconButtonProps>`
  position: fixed;
  right: ${dynamicStylingHelper('0', SYS_SPACE_FIXED_100)};
  top: ${dynamicStylingHelper('0', SYS_SPACE_FIXED_100)};
  border: none;

  button {
    border: none;
  }
`;

export const StyledAdvancedFiltersButton = styled((props) => (
  <TextButton {...props} />
))<IconButtonProps>`
  width: 100%;
  box-shadow: none;
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    box-shadow: inset 0 0 0 1px ${GetSafeColorDesignToken('INDICATOR_DEFAULT_DARK')};
  }
`;
